module.exports = __webpack_public_path__ + "img/iadsa-section-loader-admin.48439f4b.gif";